<ng-container *ngIf="items$ | async as items">
  <div class="flex justify-content-start align-items-center" *ngIf="items?.length > 0">
    <p-breadcrumb class="w-full" [model]="items" [home]="home"></p-breadcrumb>
    <div class="pl-2" *ngIf="isMapEditor$ | async">
      <cytoscape-map-buttons></cytoscape-map-buttons>
    </div>
  </div>
</ng-container>
